
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { NextSeo } from 'next-seo'
import useTranslation from 'next-translate/useTranslation'
import { useState } from 'react'
import { useQuery } from '@/app/common/graphql/hooks'
import SearchInput from '@/components/SearchInput'
import CarFormLabel from '@/domains/car/components/CarForm/CarFormLabel'
import CarFormProgress from '@/domains/car/components/CarForm/CarFormProgress'
import CarFormStep from '@/domains/car/components/CarForm/CarFormStep'
import Option from '@/domains/car/components/CarForm/Option'
import {
  parseMake,
  parsePayoutAmount,
} from '@/domains/car/helpers/parseCarFormQuery'
import {
  PageProps,
  createGetServerSideProps,
} from '@/helpers/createGetServerSideProps'
import { useSearchParams } from '@/helpers/useSearchParams'
import {
  GetCarMakeModelsDocument,
  GetCarMakeModelsQuery,
  GetCarMakeModelsQueryVariables,
} from '@/types/gql/graphql'

interface ModelPageProps extends PageProps<{}> {
  make: string
}

export default function CarFormModelStep({ make }: ModelPageProps) {
  const { t } = useTranslation('carPawnFormModelStep')
  const queryParams = useSearchParams()

  const [searchTerm, setSearchTerm] = useState('')
  const searchValue = searchTerm.toLowerCase()
  const getModelsRes = useQuery<
    GetCarMakeModelsQuery,
    GetCarMakeModelsQueryVariables
  >(GetCarMakeModelsDocument, {
    variables: { args: { make: make } },
    enableCaching: true,
  })

  const filteredModels = getModelsRes.data?.carMakeModels?.filter((model) =>
    model.toLowerCase().includes(searchValue),
  )

  const isSearching = searchTerm !== ''
  return (
    <CarFormStep step={2}>
      <NextSeo noindex nofollow title={t('title')} />

      <div>
        <CarFormProgress step={2} />

        <h1 className="text-heading-m text-primary text-center my-2">
          {t('pick_model')}
        </h1>
      </div>

      <SearchInput
        label={t('search_models')}
        value={searchTerm}
        onChange={(event) => setSearchTerm(event.target.value)}
        onClearClick={() => setSearchTerm('')}
        className="shrink-0"
      />

      <section>
        <CarFormLabel>
          {!isSearching || !filteredModels
            ? t('all_models', { make })
            : filteredModels.length > 0
              ? t('matching_models', { make })
              : t('no_matching_models', { make, searchTerm })}
        </CarFormLabel>
        <div className="flex flex-col gap-2" role="listbox">
          {filteredModels?.map((model) => (
            <Option
              href={{
                pathname: '/autopfand-formular/zulassungsjahr',
                query: {
                  ...queryParams,
                  modell: model,
                },
              }}
              key={model}
            >
              {model}
            </Option>
          ))}
        </div>
      </section>
    </CarFormStep>
  )
}

 const _getServerSideProps = createGetServerSideProps<ModelPageProps>({
  async getServerSideProps({ context, client }) {
    const [payoutAmount, r1] = parsePayoutAmount(context.query.betrag)
    if (r1) {
      return {
        redirect: { permanent: true, destination: r1.redirect },
      }
    }
    const [make, r2] = parseMake(context.query.marke, payoutAmount.betrag)
    if (r2) {
      return {
        redirect: { permanent: true, destination: r2.redirect },
      }
    }

    const res = await client.executeQuery<
      GetCarMakeModelsQuery,
      GetCarMakeModelsQueryVariables
    >({
      document: GetCarMakeModelsDocument,
      variables: { args: { make: make.marke } },
    })

    if (!res.data.carMakeModels) {
      console.warn('Fetch car models: unknown make', make)

      return {
        redirect: { permanent: true, destination: '/autopfand-formular' },
      }
    }

    return { props: { make: make.marke } }
  },
})


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/autopfand-formular/modell',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  